<template>
    <div class="empty-layout"><RouterView></RouterView></div>
</template>
<style>
    .empty-layout { padding: 20px; }
</style>